import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PageWithMenu from 'components/PageWithMenu';
import Changelog from './Changelog';

const ChangelogContainer = ({ role_code }) => {
  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageWithMenu title="Changelog" role_code={role_code} path="/changelog">
      <Changelog />
    </PageWithMenu>
  );
};

ChangelogContainer.propTypes = {
  role_code: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    role_code: state.auth.profile ? state.auth.profile.role_code : null,
  };
}

export default connect(mapStateToProps)(ChangelogContainer);
